import DetailsDataViewer from "./DetailsDataViewer.js";
import EditDetailsAction from "./actions/EditDetailsAction.js";
const install = molten => {
  // DataViewers
  molten.addPlugin('DataViewer', DetailsDataViewer);

  // Actions
  molten.addPlugin('Action', EditDetailsAction);
};
export default {
  install
};